import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Page,
  Text,
} from '../../../components';
import api from '../../../utils/services';
import clientUrl from './clientUrl';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      clientId: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

// Note: This component tests out React hooks on a non-critical component.
// Please do not use hooks until we have determined their stability
// If we do decide to use Hooks, add https://www.npmjs.com/package/eslint-plugin-react-hooks
// to help avoid any gotchas
// This note exists in ViewCarrier as well
export default function ViewClient(props) {
  const { match: { params: { clientId } } } = props;

  const [client, setClient] = useState(null);
  useEffect(() => {
    api.getClient(clientId)
      .then((clientData) => {
        setClient(clientData);
      });
  }, [clientId]);

  let clientMarkup = '';
  if (client !== null) {
    clientMarkup = (
      <div>
        <Text>{`Client Id: ${client.id}`}</Text>
        <Text>{`Name: ${client.name}`}</Text>
        <Text>{`Subdomain: ${client.subdomain}`}</Text>
      </div>
    );
  }

  return (
    <Page
      breadcrumbs={[{ content: 'Clients', href: '/settings/clients' }]}
      title={client === null ? 'Loading...' : `${client.name}`}
      secondaryActions={client === null ? undefined : [{
        content: 'Switch To Client',
        // Cannot use href since that uses the internal router
        onClick: () => { window.location = clientUrl(client.subdomain); },
      }]}
    >
      {clientMarkup}
    </Page>
  );
}

ViewClient.propTypes = propTypes;
